import React, { useState } from 'react';

const ProgressBar = ({ stepNum, identity }) => {
  const [step, setStep] = useState(stepNum);

  let totalSteps;
  if (identity === 'Device select') {
    totalSteps = 5;
  } else if (identity === 'Automation') {
    totalSteps = 3;
  } else if (identity === 'Create Group') {
    totalSteps = 3;
  } else {
    totalSteps = 5; // fallback if needed
  }
  let stepLabels;
  if (identity === 'Device select') {
    stepLabels = ['SELECTED DEVICES', 'THIRD PARTY PATCHES', 'OS UPDATES', 'ACTIONS', 'PREVIEW & TEST'];
  } else if (identity === 'Automation') {
    stepLabels = ['CREATE', 'THIRD PARTY', 'OPERATING SYSTEM UPDATE'];
  } else if (identity === 'Create Group') {
    stepLabels = ['SELECTED DEVICES', 'MAINTENANCE SCHEDULE', 'REBOOT SCHEDULE'];
  } else {
    stepLabels = ['SELECTED DEVICES', 'THIRD PARTY PATCHES', 'OS UPDATES', 'ACTIONS', 'PREVIEW & TEST']; // fallback if needed
  }

  return (
    <div
      style={{
        background: 'var(--Card-Color, #1D1D1D)',
        padding: '30px',
        position: 'relative',
        width: '100%', // Full width
      }}
    >
      {/* Single Continuous Line */}
      <div
        style={{
          position: 'absolute',
          top: '40%',
          left: identity === 'Automation' ? '3%' : '8%', // Adjusted left position
          width: identity === 'Create Group' ? '80%' : '85%', // Adjusted width to fit better
          height: '4px',
          backgroundColor: '#555',
          transform: 'translateY(-50%)',
          zIndex: 0,
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: `${step > 1 ? ((step - 1) / (totalSteps - 1)) * 100 : 8}%`,
            height: '100%',
            backgroundColor: '#39FF14',
            zIndex: 0,
          }}
        ></div>
      </div>

      {/* Step Circles and Labels */}
      <div className="flex justify-between relative" style={{ zIndex: 1 }}>
        {Array.from({ length: totalSteps }, (_, index) => (
          <div key={index} className="flex flex-col items-center" style={{ position: 'relative' }}>
            {/* Step Circle */}
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold ${
                index < step ? 'bg-green-500 text-white' : 'bg-gray-700 text-white'
              }`}
              style={{
                position: 'relative',
                zIndex: 2,
                width: '40px', // Slightly larger
                height: '40px',
                fontSize: '1rem',
              }}
            >
              {index + 1}
            </div>

            {/* Label Below Circle */}
            <div
              style={{
                color: '#FFF',
                marginTop: '10px',
                fontSize: '14px', // Slightly larger
                whiteSpace: 'nowrap',
                textAlign: 'center',
                zIndex: 2,
              }}
            >
              {stepLabels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
